import React from "react";
import { Link } from "react-router-dom";

export default function PanelNav() {
  return (
    <>
      <div className="lg:flex lg:col-span-2 xl:col-span-1 flex-col hidden py-5">
        <Link to="/panel">
          <div className="flex items-end justify-start py-2 cursor-pointer hover:text-gray-500">
            <span className="pl-2 text-lg">My Information</span>
          </div>
        </Link>

        <Link to="/servers">
          <div className="flex items-end justify-start py-2 cursor-pointer hover:text-gray-500">
            <span className="pl-2 text-lg">Servers</span>
          </div>
        </Link>

        <Link to="/myservers">
          <div className="flex items-end justify-start py-2 cursor-pointer hover:text-gray-500">
            <span className="pl-2 text-lg">My Servers</span>
          </div>
        </Link>

        <Link to="/withdraw">
          <div className="flex items-end justify-start py-2 cursor-pointer hover:text-gray-500">
            <span className="pl-2 text-lg">Withdraw</span>
          </div>
        </Link>

        <Link to="/deposit">
          <div className="flex items-end justify-start py-2 cursor-pointer hover:text-gray-500">
            <span className="pl-2 text-lg">Deposit</span>
          </div>
        </Link>

        <Link to="/paycolife">
          <div className="flex items-end justify-start py-2 cursor-pointer hover:text-gray-500">
            <span className="pl-2 text-lg">How is it work</span>
          </div>
        </Link>
      </div>
    </>
  );
}
